export class Auth {

	ajaxAuth(parent) {
		let _this = this;
		$(parent).find('button').attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=sms_login',
			dataType: "json",
			success: function (res) {
				$(parent).find('button').attr('disabled', false);

				if (res['success']) {
					$("body").addClass("no-scroll");
					$('.popup-auth-code .popup-auth__card--phone_number').text(parent.str_phone.value);
					$('.popup-auth-code').addClass("active");
					_this.startTimer();
				}
				else {
					_this.showMistake(parent, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				$(parent).find('button').attr('disabled', false);
				_this.showMistake(parent, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	startTimer(type = 'sms') {
		let time = 30;
		let intervalId;
		
		// Choose selectors based on context
		let selectors;
		if (type === 'signup') {
			// New signup form selectors
			selectors = {
				container: '.signup-code-form__repeat',
				button: '.signup-resend-btn',
				timer: '.signup-code-form__repeat-timer'
			};
			intervalId = 'signupIntervalId';
		} else {
			// Old popup selectors (for existing functionality)
			selectors = {
				container: '.popup-auth-code__repeat',
				button: '.popup-auth-code__repeat-btn',
				timer: '.popup-auth-code__repeat span'
			};
			intervalId = 'intervalId';
		}

		if (this[intervalId]) {
			clearInterval(this[intervalId]);
		}

		// Show container and disable button
		$(selectors.container).fadeIn();
		$(selectors.button).prop('disabled', true);
		
		// Initialize timer display
		if (type === 'signup') {
			$(selectors.timer).text('00:' + (time < 10 ? '0' + time : time));
		} else {
			$(selectors.timer).show();
			$(selectors.timer).text('  (через ' + time + ' сек)');
		}

		let _this = this;
		this[intervalId] = setInterval(function () {
			time--;
			
			if (type === 'signup') {
				$(selectors.timer).text('00:' + (time < 10 ? '0' + time : time));
			} else {
				$(selectors.timer).text('  (через ' + time + ' сек)');
			}
			
			if (time == 0) {
				clearInterval(_this[intervalId]);
				
				if (type === 'signup') {
					$(selectors.button).prop('disabled', false);
				} else {
					$(selectors.timer).hide();
					$(selectors.button).prop('disabled', false);
				}
			}
		}, 1000);
	}

	async regPhone(type = 'auto') {
		$('.popup-auth-tel .auth-form__submit').prop('disabled', true);
		let _this = this;

		let recpatchaSelector = document.querySelector('meta[name="captcha"]');
		let recaptchaToken = "";
		if (recpatchaSelector) {
			let recpatchaKey = recpatchaSelector.content;
			recaptchaToken = await grecaptcha.execute(recpatchaKey, { action: 'submit' });
		}

		$.ajax({
			url: "/ajax.php?mid=22",
			type: 'POST',
			data: {
				action: 'reg_phone',
				str_phone: $('.popup-auth-tel #auth-tel').val(),
				type: type,
				token: recaptchaToken,
			},
			dataType: "json",
			success: function (res) {
				if (res.success) {
					$('.popup-auth-tel').removeClass('active');
					$('.popup-auth-tel .form__mistakes').text('');

					if (type == 'sms') {
						_this.codePopup('sms');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						_this.startTimer('sms');
					}
					else if (res.email) {
						_this.codePopup('email');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						$('.popup-auth-code .founded_email').text(res.email);
						_this.startTimer('email');
					}
					else {
						_this.codePopup('flashcall');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						_this.startTimer('flashcall');
					}

					$('.popup-auth-tel .form__mistakes').text('');
					$('.popup-auth-tel .form__mistakes').hide();
				}
				else {
					$('.popup-auth-tel .form__mistakes').text(res.error);
					$('.popup-auth-tel .form__mistakes').show();
				}

				$('.popup-auth-tel .auth-form__submit').prop('disabled', false);
			},
			error: function (res) {
				$('.popup-auth-tel .auth-form__submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	submitCode(parent) {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=check_code',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(parent);
					location.reload();
				}
				else {
					_this.showMistake(parent, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				_this.showMistake(parent, 'Ошибка: ' + res);
				console.log(res);
			}
		});
	}

	submitCodeOrder(parent) {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=check_code',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(parent);
					order.makeOrder($('form.order')[0]);
				}
				else {
					_this.showMistake(parent, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				_this.showMistake(parent, 'Ошибка: ' + res);
				console.log(res);
			}
		});
	}

	regUser() {
		$('#reg_user_submit').prop('disabled', true);
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=7",
			type: 'POST',
			data: $('.auth__reg form').serialize() + '&action=reg_user',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake('#reg_block');
					$('.auth__reg').hide();
					//$('#reg_step_3').fadeIn();
					if (res.get_bonus)
						location.replace('/cabinet/gifts/#show_gift_' + res.order_id);
					else
						location.replace('/');
				}
				else {
					_this.showMistake('.auth__reg', res.error);
				}
			},
			error: function (res) {
				$('#reg_user_submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	smsCodeInput(parent) {
		let code = $(parent).val();
		let digits = parseInt(code).toString().length;
		if (digits == 5) {
			$('#sms_code_submit').prop('disabled', false);
		}
		else {
			$('#sms_code_submit').prop('disabled', true);
		}
	}

	resetPass(parent) {
		let _this = this;
		let form = $(parent);
		let phone = form.find('input[name=str_phone]').val();
		form.find('input[type=submit]').prop('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=6",
			type: 'POST',
			data: { action: 'reset_pass', phone: phone },
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(form);
					_this.hidePopup(form.closest('.popup'));
				}
				else {
					_this.showMistake(form, res.error);
				}
			},
			error: function (res) {
				form.find('input[type=submit]').prop('disabled', false);
				console.log(res);
			}
		});
	}

	showMistake(block, text) {
		$(block).find('.form__mistakes').text(text);
		$(block).find('.form__mistakes').show();
	}

	hideMistake(block) {
		$(block).find('.form__mistakes').text('');
		$(block).find('.form__mistakes').hide();
	}

	hidePopup(popup) {
		$("body").removeClass("no-scroll");
		popup.removeClass("active");
	}

	ajaxLogin(parent) {
		let _this = this;
		$(parent).find('button').attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=login',
			dataType: "json",
			success: function (res) {
				$(parent).find('button').attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(parent);
					//location.reload();
					location.href = '/crm/';
				}
				else {
					_this.showMistake(parent, res['error']);
				}
			},
			error: function (res) {
				$(parent).find('button').attr('disabled', false);
				_this.showMistake(parent, 'Error sending data. Please try again or contact site administrator');
			}
		});
	}

	ajaxRegister(parent) {
		let _this = this;
		$(parent).find('button[type="submit"]').attr('disabled', true);

		// Client-side password validation
		const password = $(parent).find('input[name="ntd_password"]').val();
		const passwordConfirm = $(parent).find('input[name="ntd_password_confirm"]').val();
		
		if (password !== passwordConfirm) {
			_this.showMistake(parent, 'Passwords do not match');
			$(parent).find('button[type="submit"]').attr('disabled', false);
			return;
		}
		
		if (!_this.validatePassword(password)) {
			_this.showMistake(parent, 'Password does not meet requirements');
			$(parent).find('button[type="submit"]').attr('disabled', false);
			return;
		}

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=register_user',
			dataType: "json",
			success: function (res) {
				$(parent).find('button[type="submit"]').attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(parent);
					
					// Show email in code form
					$('.signup-email-display').text($(parent).find('input[name="str_email"]').val());
					
					// Clear code inputs
					$('.signup-code-form__input').val('');
					
					// Hide main form and show code form
					$('.signup-main-form').hide();
					$('.signup-code-form').show();
					
					// Set focus to first code input
					setTimeout(() => {
						$('.signup-code-form__input:first').focus();
					}, 100);
					
					// Start timer
					_this.startTimer('signup');
				}
				else {
					_this.showMistake(parent, res['error']);
				}
			},
			error: function (res) {
				$(parent).find('button[type="submit"]').attr('disabled', false);
				_this.showMistake(parent, 'Error sending data. Please try again or contact site administrator');
			}
		});
	}

	ajaxVerifyCode(parent) {
		let _this = this;
		$(parent).find('button[type="submit"]').attr('disabled', true);

		// Collect code from all 4 fields and combine into single string
		let codeFields = $(parent).find('input[name="code[]"]');
		let code = '';
		codeFields.each(function() {
			code += $(this).val();
		});

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: {
				code: code,
				action: 'check_code'
			},
			dataType: "json",
			success: function (res) {
				$(parent).find('button[type="submit"]').attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(parent);
					location.reload();
				}
				else {
					_this.showMistake(parent, res['error']);
				}
			},
			error: function (res) {
				$(parent).find('button[type="submit"]').attr('disabled', false);
				_this.showMistake(parent, 'Error sending data. Please try again or contact site administrator');
			}
		});
	}



	// Step navigation for signup form
	nextStep() {
		$('.signup-main-form__step.active').removeClass('active').next('.signup-main-form__step').addClass('active');
	}

	prevStep() {
		$('.signup-main-form__step.active').removeClass('active').prev('.signup-main-form__step').addClass('active');
	}

	// Validate current step and go to next step
	validateAndNextStep(button) {
		const $currentStep = $('.signup-main-form__step.active');
		const $inputs = $currentStep.find('input[required]');
		let isValid = true;

		$inputs.each(function() {
			if (!$(this).val().trim()) {
				isValid = false;
				$(this).addClass('error');
			} else {
				$(this).removeClass('error');
			}
		});

		if (!isValid) {
			this.showMistake('.signup-main-form', 'Please fill in all required fields');
			return false;
		} else {
			this.hideMistake('.signup-main-form');
			this.nextStep();
		}
	}

	// Go back to email step from code form
	goToEmailStep() {
		// Clear code inputs
		$('.signup-code-form__input').val('');
		
		$('.signup-code-form').hide();
		$('.signup-main-form').show();
		// Go to step 2 (email and password)
		$('.signup-main-form__step.active').removeClass('active');
		$('.signup-main-form__step').last().addClass('active');
	}

	// Resend signup verification code
	resendSignupCode() {
		let _this = this;
		$('.signup-resend-btn').prop('disabled', true);

		// Get email from the displayed email
		const email = $('.signup-email-display').text();

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: {
				str_email: email,
				action: 'register_user'
			},
			dataType: "json",
			success: function (res) {
				if (res['success']) {
					// Clear code inputs and focus first one
					$('.signup-code-form__input').val('');
					setTimeout(() => {
						$('.signup-code-form__input:first').focus();
					}, 100);
					
					_this.startTimer('signup');
				} else {
					_this.showMistake('.signup-code-form', res['error']);
					$('.signup-resend-btn').prop('disabled', false);
				}
			},
			error: function (res) {
				_this.showMistake('.signup-code-form', 'Error sending code. Please try again.');
				$('.signup-resend-btn').prop('disabled', false);
			}
		});
	}

	// Password validation
	validatePassword(password) {
		const rules = {
			hasLetter: /[a-zA-Z]/.test(password),
			hasNumberOrSpecial: /[\d\W]/.test(password),
			hasMinLength: password.length >= 10
		};

		// Update visual indicators
		$('.form-password-item__must-item').each(function(index) {
			const $item = $(this);
			let isValid = false;

			switch(index) {
				case 0: // 1 letter
					isValid = rules.hasLetter;
					break;
				case 1: // 1 number or special character
					isValid = rules.hasNumberOrSpecial;
					break;
				case 2: // 10 characters
					isValid = rules.hasMinLength;
					break;
			}

			if (isValid) {
				$item.addClass('valid');
			} else {
				$item.removeClass('valid');
			}
		});

		return rules.hasLetter && rules.hasNumberOrSpecial && rules.hasMinLength;
	}

	applyEvents() {
		let _this = this
		$('.header__login-form').submit(function () {
			_this.ajaxAuth();
			return false;
		});

		// Hide code form by default
		$('.signup-code-form').hide();
		
		// Initialize code input functionality
		_this.initCodeInputs();
	}

	// Initialize code input functionality for 4-field code entry
	initCodeInputs() {
		const form = document.querySelector('.signup-code-form');
		if (!form) return;

		const inputs = form.querySelectorAll(".signup-code-form__input");
		if (inputs.length === 0) return;

		// Set focus to first empty field
		const setFocusToFirstEmpty = () => {
			for (const input of inputs) {
				if (input.value === "") {
					input.focus();
					break;
				}
			}
		};

		// Handle digit input
		inputs.forEach((input, index) => {
			input.addEventListener("input", (event) => {
				const value = event.target.value;

				// Limit input to single digit only
				if (!/^[0-9]$/.test(value)) {
					input.value = "";
					return;
				}

				// Move focus to next field if available
				if (index < inputs.length - 1) {
					inputs[index + 1].focus();
				} else {
					// If last field is filled, submit form
					if (Array.from(inputs).every((inp) => inp.value !== "")) {
						$(form).trigger('submit');
					}
				}
			});

			// Handle Backspace key
			input.addEventListener("keydown", (event) => {
				if (event.key === "Backspace") {
					if (input.value === "") {
						if (index > 0) {
							const previousInput = inputs[index - 1];
							previousInput.focus(); // Move focus to previous field
							previousInput.value = ""; // Clear value in previous field
						}
					} else {
						input.value = ""; // Clear current field
					}
					event.preventDefault(); // Prevent default behavior
				}
			});

			// Select content when clicking on field
			input.addEventListener("mousedown", (event) => {
				if (input.value !== "") {
					event.preventDefault(); // Prevent deselection
					input.select();
				}
			});

			input.addEventListener("focus", () => {
				if (input.value !== "") {
					input.select();
				} else {
					setFocusToFirstEmpty();
				}
			});
		});

		// Handle paste from clipboard
		inputs.forEach((input) => {
			input.addEventListener("paste", (event) => {
				event.preventDefault();
				const pasteData = (event.clipboardData || window.clipboardData).getData("text");

				if (/^[0-9]+$/.test(pasteData)) {
					// Fill fields starting from first
					const digits = pasteData.split("");
					inputs.forEach((inp, idx) => {
						inp.value = digits[idx] || "";
					});

					// Set focus to first empty field
					setFocusToFirstEmpty();

					// If all fields are filled, submit form
					if (Array.from(inputs).every((inp) => inp.value !== "")) {
						$(form).trigger('submit');
					}
				}
			});
		});
	}

}

